<h4>AOS Order Nr. {{order.nr}}</h4>
<div class="mt-3 mb-3">
  <div class="row">
    <div class="col-md-4">
      <div class="card card-preview"><span><i class="fas fa-times"></i> {{i18n.get('global_no_preview_label')}}}</span>
      </div>
    </div>
    <div class="col-md-4">
      <dl>
        <dt>{{i18n.get('orders_created_on_label', 'orders')}}</dt>
        <dd>{{getDate()}} by <u>{{this.order.userFullName}}</u></dd>
        <dt *ngIf="order.status">{{i18n.get('global_status_label')}}</dt>
        <dd *ngIf="order.status">{{order.status}}</dd>
        <dt>{{i18n.get('orders_product_type_label', 'orders')}}</dt>
        <dd>{{order.productTypeLabel}}</dd>
        <dt>{{i18n.get('global_width_label')}}</dt>
        <dd>{{order.d_width}}{{order.d_unit}}</dd>
        <dt>{{i18n.get('global_height_label')}}</dt>
        <dd>{{order.d_height}}{{order.d_unit}}</dd>
        <dt>{{i18n.get('global_bleed_label')}}</dt>
        <dd>{{decodedOrderData.factorBleed}}{{order.d_unit}}</dd>
        <dt>{{i18n.get('global_colorimetry_label')}}</dt>
        <dd>{{decodedOrderData.printTypeColor}}</dd>
        <dt *ngIf="order.d_printType">{{i18n.get('global_print_type_label')}}</dt>
        <dd *ngIf="order.d_printType">{{order.d_printType}}</dd>
        <!-- Order file name
        <dt *ngIf="this.decodedOrderData.orderFileName">Name of supplied file</dt>
        <dd *ngIf="this.decodedOrderData.orderFileName">{{this.decodedOrderData.orderFileName}}</dd>
        -->
        <dt>{{i18n.get('orders_product_remark_label', 'orders')}}</dt>
        <dd>{{decodedOrderData.poolRemarks || i18n.get('global_no_comment_label')}}</dd>
      </dl>
    </div>
    <div class="col-md-4">
      <dl>
        <dt>{{i18n.get('global_company_label')}}</dt>
        <dd>
          <span>{{this.order.company_label}}</span><br>
          <span *ngIf="this.order.companyAdditionalLine1">{{this.order.companyAdditionalLine1}}<br></span>
          <span *ngIf="this.order.companyAdditionalLine2">{{this.order.companyAdditionalLine2}}<br></span>
          <span *ngIf="this.order.companyStreet && !this.order.companyPoBox">{{this.order.companyStreet}}<br></span>
          <span
            *ngIf="this.order.companyStreet && this.order.companyPoBox">{{this.order.companyStreet}} {{this.order.companyPoBox}}
            <br></span>
          <span *ngIf="this.order.companyPlace &&  !this.order.companyZip">{{this.order.companyPlace}}<br></span>
          <span
            *ngIf="this.order.companyPlace &&  this.order.companyZip">{{this.order.companyZip}} {{this.order.companyPlace}}
            <br></span>
          <span *ngIf="this.order.companyCountry">{{this.order.companyCountry}}<br></span>
          <span *ngIf="this.order.companyFax"><i class="fas fa-sm fa-fax"></i> {{this.order.companyFax}}<br></span>
          <span *ngIf="this.order.companyPhone"><i class="fas fa-sm fa-phone"></i> {{this.order.companyPhone}}
            <br></span>
          <span *ngIf="this.order.companyEmail"><i class="fas fa-sm fa-at"></i> {{this.order.companyEmail}}</span>
        </dd>
        <dt>{{i18n.get('global_market_label')}}</dt>
        <dd>{{this.order.country_label}}</dd>
        <dt *ngIf="this.order.magazine_printTitle">Magazine / Newspaper title</dt>
        <dd *ngIf="this.order.magazine_printTitle">{{this.order.magazine_printTitle}}</dd>
        <dt *ngIf="this.decodedOrderData.publicationDate">Publication date</dt>
        <dd *ngIf="this.decodedOrderData.publicationDate">{{getPublicationDate()}}</dd>
        <dt *ngIf="this.order.shipmentDate">Shipment date</dt>
        <dd *ngIf="this.order.shipmentDate">{{getShipmentDate()}}</dd>
        <dt *ngIf="decodedOrderData.deliverMethod">Delivery</dt>
        <dd *ngIf="decodedOrderData.deliverMethod">{{decodedOrderData.deliverMethod}}</dd>
        <dt>{{i18n.get('orders_order_remark_label', 'orders')}}</dt>
        <dd>{{order.orderRemarks || i18n.get('global_no_comment_label')}}</dd>
      </dl>
    </div>
  </div>
</div>
<!--
<pre><code>{{ order | json }}</code></pre>
<pre><code>{{ decodedOrderData | json }}</code></pre>
<pre><code>{{ decodedOrderAddressFields | json }}</code></pre>
-->
